import { render, staticRenderFns } from "./languageDataConf.vue?vue&type=template&id=075bb6ce&"
import script from "./languageDataConf.vue?vue&type=script&lang=js&"
export * from "./languageDataConf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports